// Este codigo fue generado por Github Copilot Chat
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractControlValueAccessorComponent } from '../../helpers/abstract-control-value-accessor';
import { debounceTime, fromEvent, map, Subscription } from 'rxjs';

@Component({
  selector: 'app-input-search',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSearchComponent),
      multi: true
    }
  ]
})
export class InputSearchComponent
  extends AbstractControlValueAccessorComponent<string>
  implements AfterViewInit, OnDestroy
{
  @Output() searchChange = new EventEmitter<string>();
  @Output() positionChange = new EventEmitter<number>();
  @ViewChild('inputSearch') inputElement!: ElementRef;
  @Input() time = 500;
  event!: Subscription;

  constructor() {
    super();
  }

  override writeValue(value: string): void {
    super.writeValue(value);
    if (this.inputElement) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.inputElement.nativeElement.value = value || '';
    }
  }

  ngAfterViewInit() {
    this.event = fromEvent<Event>(
      this.inputElement.nativeElement as HTMLInputElement,
      'input'
    )
      .pipe(
        debounceTime(this.time),
        map((event: Event) => (event.target as HTMLInputElement).value)
      )
      .subscribe((query: string) => {
        this.onChange(query); // Actualizar el FormControl
        this.searchChange.emit(query);
        this.updateDropdownPosition();
      });
  }

  ngOnDestroy(): void {
    this.event.unsubscribe();
  }

  updateDropdownPosition() {
    const inputElement = this.inputElement.nativeElement as HTMLInputElement;
    const inputRect = inputElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    let position: number;

    if (viewportHeight - inputRect.bottom > 150) {
      position = inputRect.bottom + window.scrollY;
    } else {
      position = inputRect.top + window.scrollY - 150;
    }

    this.positionChange.emit(position); // Emitir la posición calculada
  }
}
// Este codigo fue generado por Github Copilot Chat
